import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PagingSidePanelType, Box as Section, SidePanel, Tabs } from '@node-space/ui-components'
import { appBannersId } from 'components/app/AppBanners'
import { useComponentHeight } from 'hooks/useComponentHeight'
import { PayloadView } from 'pages/Channels/components/PayloadView'
import { PaymentsResponse } from 'types/payments'
import { highlightRowBasedOnId } from 'utils/table/table'
import { sortObjectPropertiesByName } from 'utils/utils'
import PaymentDetails from '../Table/PaymentDetails'
import { PaymentTimeline } from '../Table/Timeline/PaymentTimeline'
import { CryptoPaymentsSidePanelHeader } from './CryptoPaymentsSidePanelHeader'

interface CryptoPaymentsSidePanelProps {
  isOpen: boolean
  paging: PagingSidePanelType
  onClose: () => void
  cryptoPaymentDetails: PaymentsResponse
}

export const CryptoPaymentsSidePanel = ({
  isOpen,
  paging,
  onClose,
  cryptoPaymentDetails,
}: CryptoPaymentsSidePanelProps) => {
  const { t } = useTranslation()
  const bannerSpacing = useComponentHeight(appBannersId)

  const { reference, uuid, dateCreated } = cryptoPaymentDetails || {}

  const smallTabsId = `${reference}-${uuid}-${dateCreated}`
  const [activeId, setActiveId] = useState(smallTabsId)

  useEffect(() => {
    setActiveId(smallTabsId)
  }, [activeId])

  const payloadJsonString = JSON.stringify(
    sortObjectPropertiesByName(cryptoPaymentDetails || {}),
    null,
    3
  )

  return (
    <SidePanel
      id="side-panel-transaction-details"
      isOpen={isOpen}
      paging={paging}
      onClose={onClose}
      activeRowId={cryptoPaymentDetails?.reference}
      onActiveRowChange={highlightRowBasedOnId}
      externalStyle={{ top: `${bannerSpacing}px` }}
      header={<CryptoPaymentsSidePanelHeader cryptoPaymentDetails={cryptoPaymentDetails} />}
      body={
        <Section tag="section" width="full" background="layer-1">
          <Tabs
            tabs={[
              {
                id: 'details',
                header: t('details'),
                content: <PaymentDetails transaction={cryptoPaymentDetails} />,
                testId: 'payment-row-details-tab',
              },
              {
                id: 'updates',
                header: t('payments.updates'),
                content: <PaymentTimeline transaction={cryptoPaymentDetails} />,
                testId: 'payment-row-updates-tab',
              },
              {
                id: 'full-payload',
                header: t('fullPayload'),
                content: <PayloadView jsonString={payloadJsonString} />,
              },
            ]}
          />
        </Section>
      }
    ></SidePanel>
  )
}
